import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=175a18a9&scoped=true&"
import script from "./IconUser.vue?vue&type=script&lang=js&"
export * from "./IconUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a18a9",
  null
  
)

export default component.exports